
import { Component, Vue, Prop } from 'vue-property-decorator';
import { LavorazioneSlim, MetadataType } from '@/models';

@Component
export default class CardLavorazione extends Vue {
    @Prop() private lavorazione!: LavorazioneSlim;
    @Prop({ default: false }) private compact!: boolean;

    private metadataType = MetadataType;

    private iconClassByProgress(lav: LavorazioneSlim): string {
        if (lav.progresso == 0) {
            return 'grey';
        } else if (lav.progresso == 100) {
            return 'green';
        }

        return 'amber';
    }
    private getChipColorByHashedString(nome: string): string {
        const colorArray = ["grey", "red", "pink", "purple", "deep-purple", "indigo", "blue", 
        "light-blue", "cyan", "teal", "green", "light-green", "lime", "yellow", "amber",
        "orange", "deep-orange", "brown", "blue-grey"];
        var hash = 0, i, chr;      
        for (i = 0; i < nome.length; i++) {
            chr   = nome.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        if(hash < 0) hash = -hash;
        return colorArray[hash % colorArray.length];
    }
    private showDetail() {
        this.$router.push({ name: 'riga', params: { id: this.lavorazione.id }});
    }
}
